import React from 'react'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { Alerts, CopyAndPaste, InputButton } from '../../../Simple'
import { Modal, Box, CardHeader, Typography } from '@mui/material'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import { IoChevronBack } from 'react-icons/io5'
import { AuthContext } from '../../../../contexts/AuthContext'
import { pixAgendei } from '../../../../assets'
import PassosPagPix from './PassosPagPix'
import RouterHook from '../../../../contexts/RouterHook'
import { styled } from '@mui/material/styles'
import { BiX } from 'react-icons/bi'
import QrCode from 'qrcode.react'
import { io } from 'socket.io-client'

import { stMob } from './stylesP'

export default function PixPendente() {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { sttCtxChkt, actionsChkt } = React.useContext(CheckoutContext)
  const serverRouter = RouterHook()
  const socketRef = React.useRef(null)
  const [modalInfos, setModalInfos] = React.useState(false)

  function Temporizador() {
    const [remainingTime, setRemainingTime] = React.useState(null)
    const [progress, setProgress] = React.useState(100)

    const BorderLinearProgress = styled(LinearProgress)(() => ({
      width: '100%',
      height: 10,
      borderRadius: 5,
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#f6f6f6',
      },
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#ff7043',
      },
    }))

    React.useEffect(() => {
      const endTime = new Date(sttCtxChkt.payment.dataExpiracaoChavePix).getTime()
      const startTime = new Date(sttCtxChkt.payment.createdAt).getTime()
      const totalTime = endTime - startTime

      const intervalId = setInterval(() => {
        const now = new Date().getTime()
        const diff = endTime - now
        const isPast = diff < 0
        if (isPast) {
          clearInterval(intervalId)
          setRemainingTime(null)
          setProgress(0)
        } else {
          const minutesLeft = Math.floor(diff / 1000 / 60)
          const secondsLeft = Math.floor((diff / 1000) % 60)
          setRemainingTime({
            minutos: minutesLeft < 10 ? '0' + minutesLeft : minutesLeft,
            segundos: secondsLeft < 10 ? '0' + secondsLeft : secondsLeft,
          })
          const prog = (diff / totalTime) * 100
          setProgress(prog)
        }
      }, 1000)

      return () => {
        clearInterval(intervalId)
      }
    }, [sttCtxChkt.payment.dataExpiracaoChavePix])

    return (
      <>
        <Typography variant='h6' className='contain-informacoes-pix-temporizador'>
          {remainingTime !== null && `${remainingTime.minutos}:${remainingTime.segundos}`}
        </Typography>
        {sttAuthCtx.isMobile && remainingTime !== null && (
          <BorderLinearProgress variant='determinate' value={progress} />
        )}
      </>
    )
  }
  React.useEffect(() => {
    if (sttCtxChkt.modePix === 'pendente') {
      // Conectar com o socket aqui!!!
      if (socketRef.current) {
        socketRef.current.disconnect()
      }

      const newSocket = io(import.meta.env.VITE_URL_SOCKET + '/monitorar-pix', {
        query: { idPagamento: sttCtxChkt.payment },
        transports: ['websocket'],
        secure: true,
      })

      newSocket.on('connect', () => {
        socketRef.current = newSocket
        newSocket.emit('acompanhar', { idpagamento: sttCtxChkt.payment.idpagamento })
        //console.log('Conectado ao socket para monitorar pagamento PIX')
      })

      newSocket.on('aprovado', buffer => {
        //console.log('Pagamento aprovado', pedido)
        // Verifica se é um pedido de agendamento ou diária
        if (sttCtxChkt.modePay === 'PEDIDO') {
          serverRouter('agendamento', buffer.idpedido)
        } else {
          serverRouter('diaria', buffer.idcompraDayuse)
        }
        // Seta o modo do pagamento para aprovado
        actionsChkt.handleSttCtxChkt('modePix', 'aprovado')
      })

      newSocket.on('disconnect', () => {
        //console.log('Socket desconectado')
      })

      return () => {
        if (socketRef.current) {
          socketRef.current.emit('abandonar', { idpagamento: sttCtxChkt.payment.idpedido })
          socketRef.current.disconnect()
          socketRef.current = null
        }
      }
    }
  }, [sttCtxChkt.modePix])
  if (sttAuthCtx.isMobile) {
    return (
      <Box sx={stMob.containPixPageMb}>
        {modalInfos && (
          <Modal
            open={modalInfos}
            onClose={() => {
              setModalInfos(false)
            }}
            sx={stMob.containOverlayModal}
          >
            <Box sx={stMob.containModal}>
              <Box sx={stMob.containTitleModal}>
                <Typography variant='h6' sx={{ fontWeight: 'bold', width: '100%' }}>
                  Como pagar com Pix
                </Typography>
                <BiX size={30} color={'#ff7043'} onClick={() => setModalInfos(false)} />
              </Box>
              <PassosPagPix />
              <InputButton
                onClick={() => {
                  setModalInfos(false)
                }}
              >
                Entendi
              </InputButton>
            </Box>
          </Modal>
        )}
        <CardHeader
          sx={stMob.containHeader}
          avatar={
            <IoChevronBack
              size={25}
              color='#ff7043'
              onClick={() => {
                serverRouter('back')
              }}
            />
          }
          title={
            <Typography variant='h5' sx={stMob.titleHeader}>
              Aguardando Pagamento
            </Typography>
          }
          subheader={
            <Typography variant='body2' component='h6'>
              {`Nº #${sttCtxChkt.payment.idpagamento}`}
            </Typography>
          }
        />
        <img src={pixAgendei} alt='Pix Agendei' className='img-pix-mobile' />
        <Typography variant='h6' sx={stMob.labelPage}>
          Copie o código abaixo e faça o pagamento utilizando a opção Pix Copia e Cola no aplicativo
          do seu banco.
        </Typography>
        <CopyAndPaste text={sttCtxChkt.payment.chavePix} />
        <Typography variant='h6' sx={{ ...stMob.labelPage, color: 'gray' }}>
          O seu código expira em:
        </Typography>
        <Temporizador />
        <InputButton
          sx={stMob.buttonOutlined}
          variant='outlined'
          onClick={() => {
            setModalInfos(true)
          }}
        >
          Como funciona?
        </InputButton>
      </Box>
    )
  } else {
    return (
      <>
        <h2 className='title-pag-me-pix'>Agendamento aguardando pagamento</h2>
        <div className='contain-row-pix'>
          <div className='contain-mid-pix'>
            <QrCode size={150} value={sttCtxChkt.payment.chavePix} />
            <div className='codigo-pix-contain'>
              <h2>{sttCtxChkt.payment.chavePix.slice(0, 25) + ' ...'}</h2>
            </div>
            <button
              onClick={async () => {
                function copyToClipboard(text) {
                  var textarea = document.createElement('textarea')
                  textarea.value = text
                  document.body.appendChild(textarea)
                  textarea.select()
                  document.execCommand('copy')
                  document.body.removeChild(textarea)
                  Alerts.swal('success', 'Código copiado com sucesso', 'Entendi')
                }
                copyToClipboard(sttCtxChkt.payment.chavePix)
              }}
            >
              Copiar Código PIX
            </button>
            <div className='contain-informacoes-pix'>
              <p className='contain-informacoes-pix-paragrafo'>
                Você tem 5 minutos para realizar o pagamento.
              </p>
              <p className='contain-informacoes-pix-paragrafo'>
                Após esse tempo, seu agendamento será cancelado.
              </p>
              <Temporizador />
            </div>
          </div>
          <PassosPagPix />
        </div>
      </>
    )
  }
}
